/**
 * Created by User on 18/02/2016.
 */
import VAST3ErrorTracker from '../../utils/VAST3ErrorTracker';
import Loader from '../../utils/Loader';
import Observer from '../../utils/Observer';
import AdConsts from '../../AdConsts';
import VAST3ErrorCodes from '../../utils/VAST3ErrorCodes';
import Logger from '../../utils/Logger';
import AdURLModificator from '../../utils/AdURLModificator';
import Utils from '../../utils/Utils';

export default VastDocument;

function VastDocument() {
  this.ERROR = "error";
  this.NOBANNER = "nobanner";
  this.COMPLETE = "complete";
  this.LOADING = "loading";

  this.currentType = null;
  this.currentURL = null;
  this.showed = false;
  this.currentState = null;
  this.prevState = null;
  this.lastStatus = null;
  this.isLinear = true;

  this.trackingData = {};
  this.trackingDataNonLinear = {};
  this.vastData = {};

  this.callback = null;

  this.logging = false;

  this.logElement = null;
  var spaceRegExr = /^\s+|\s+$/gm;

  var self = this;
  var wrapperIsLoading = false;
  var adSpeed = 1;

  this.getMedia = function (url, callback, currentType) {

    self.currentURL = url;
    self.currentType = currentType || '';
    self.callback = callback;

    self.trackingData = {};
    self.trackingDataNonLinear = {};
    self.vastData = {};
    self.isLinear = true;
    self.isImho = false;

    self.trackStarted = false;
    self.trackFirstQuartile = false;
    self.trackMidpoint = false;
    self.trackThirdQuertile = false;
    self.trackEnd = false;

    return _load(url);
  };

  var _status = function (pDescription) {
    self.lastStatus = {
      isError: self.currentState == self.ERROR || self.currentState == self.NOBANNER,
      state: self.currentState,
      prevState: self.prevState,
      message: pDescription,
      vastDocument: self
    };
    if (self.lastStatus.isError) {
      self.lastStatus['error'] = self.trackingData['error'];
    }

    if (self.logging) {
      (console._log(self.lastStatus));
    }

    return self.lastStatus;
  };

  var _setState = function (pNewState) {
    if (pNewState != self.currentState) {
      self.prevState = self.currentState;
      self.currentState = pNewState;
    }
  };

  var _load = function (pUrl) {
    VAST3ErrorTracker.reset();
    _setState(self.LOADING);
    _status('Load ' + self.currentType + ' from ' + self.currentURL);
    self.showed = true;
    self.isImho = self.isImho || (pUrl.indexOf('v.adfox.ru') !== -1 || pUrl.indexOf('/226279/') !== -1);

    var loader = new Loader();
    loader.load(pUrl, Loader.RESPONSE_TYPE_DOCUMENT,
      function (event, stats) { //success callback
        _log('loader success: ' + pUrl);
        _onXmlLoaded(event.currentTarget.responseXML, stats.tload.getTime() - stats.trequest.getTime());
      }, function (event) {
        _log('loader error: ' + pUrl);
        Observer.emit(AdConsts.XML_LOADING_ERROR);
        VAST3ErrorTracker.track(VAST3ErrorCodes.XML_PARSING_ERROR);
        _onXMLLoadedError(event);
      }, function (event) {
        VAST3ErrorTracker.track(wrapperIsLoading ? VAST3ErrorCodes.VAST_TAG_URI_TIMEOUT : VAST3ErrorCodes.XML_PARSING_ERROR);
        Observer.emit(AdConsts.XML_TIMEOUT);
        _onXMLLoadedError(event);
      }, 10000, true);


    return self.lastStatus;
  };

  var _onXMLLoadedError = function (err) {
    _close();
    _setState(self.ERROR);
    if (typeof self.callback === 'function') {
      if (err) {
        self.callback(_status('Error loading xml. Status: ' + err.status + ' ' + err.statusText));
      } else {
        self.callback(_status('Timeout on loading xml'));
      }
    }
  };

  var _onXmlLoaded = function (pXML, loadingTime) {
    var st = null;

    Observer.emit(AdConsts.XML_LOADED, loadingTime);
    try {
      if (pXML.firstChild.nodeName == 'nobanner') {
        _log('vast: nobanner');
        _setState(self.NOBANNER);
        st = _status(self.NOBANNER);
        _close();
        VAST3ErrorTracker.track(VAST3ErrorCodes.VAST_VALIDATION_ERROR);
        Observer.emit(AdConsts.NOBANNER);
      } else if (pXML.firstChild.nodeName != 'VAST') {
        _log('vast: 0');
        _setState(self.ERROR);
        st = _status('VAST tag not found!');
        _close();
        VAST3ErrorTracker.track(wrapperIsLoading ? VAST3ErrorCodes.NO_VAST_IN_WRAPPERS : VAST3ErrorCodes.VAST_VALIDATION_ERROR);
        Observer.emit(AdConsts.XML_INVALID);
      }

      for (var i = 0, length = pXML.childNodes.length; i < length; i++) {
        _processNode(pXML.childNodes[i]);
      }

    } catch (err) {
      _close();
      _setState(self.ERROR);
      st = _status(err);
      VAST3ErrorTracker.track(VAST3ErrorCodes.XML_PARSING_ERROR);
      Observer.emit(AdConsts.XML_PARSING_ERROR);
    }

    if (st != null) {
      if (typeof self.callback === 'function') {
        self.callback(st);
        return;
      }
    }

    if (self.vastData.vastadtaguri) {
      var wrapperURL = self.vastData.vastadtaguri[0];
      self.vastData.vastadtaguri = null;
      wrapperIsLoading = true;
      if (Utils.isURLisIMA(wrapperURL)) {
        if (typeof self.callback === 'function') {
          var data = {};
          data[AdConsts.GOOGLE_IN_VAST] = wrapperURL;
          self.callback(data);
        }
      } else {
        _load(wrapperURL);
      }
      return;
    } else {
      wrapperIsLoading = false;
    }

    _sendTrackingEvent('onVastLoad');

    if (self.trackingData['error']) {
      VAST3ErrorTracker.initialize(self.trackingData['error']);
    }

    if (self.vastData.mediaFile && self.vastData.mediaFile.length) {
      st = _validateDataFromPlayer();
    } else {
      _setState(self.ERROR);
      st = _status('Media file is null');
      VAST3ErrorTracker.track(VAST3ErrorCodes.VAST_VALIDATION_ERROR);
      _close();
    }

    if (typeof self.callback == 'function') {
      self.callback(st);
    }
  };

  var _validateDataFromPlayer = function () {
    var i, len, isClickable = false, ref;

    _setState(self.COMPLETE);

    var player = Observer.getObserverInstance();
    var mediaFiles = self.vastData.mediaFile;

    for (var i = 0 ; i < mediaFiles.length; i++) {
      var extension = player.utils.getExtension(mediaFiles[i].url);
      if (player.canPlay(extension, { isDrm: false })) {
        self.vastData.mediaFile = [ mediaFiles[i] ]; //find first correct mediafile and drop other
        break;
      }
    }

    var result = _status('Received video ' + self.vastData.mediaFile[0].url);

    result.isClickable = false;
    result.clickURL = null;

    if (self.vastData.mediaFile[0].duration) {
      result.duration = self.vastData.mediaFile[0].duration;
    } else if (self.vastData.duration) {
      result.duration = self.vastData.duration[0];
    } else {
      result.duration = 30;
    }
    result.skipTime = self.vastData.skipTime ? self.vastData.skipTime[0] : 0;
    result.skipTime2 = self.vastData.skipTime2 ? self.vastData.skipTime2[0] : 0;
    result.mediaFile = self.vastData.mediaFile ? self.vastData.mediaFile[0] : '';
    result.linkText = self.vastData.linkTxt ? self.vastData.linkTxt[0] : '';

    if (self.vastData['isClickable']) {
      ref = self.vastData['isClickable'];

      for (i = 0, len = ref.length; i < len; i++) {
        if (ref[i] && isClickable === false) {
          isClickable = true;
        }
      }
    }

    if (isClickable) {
      if (self.vastData['clickthrough']) {
        result.isClickable = true;
        result.clickURL = self.vastData['clickthrough'][0];
      }
      if (self.vastData['nonlinearclickthrough']) {
        result.isClickable = true;
        result.clickURL = self.vastData['nonlinearclickthrough'][0];
      }
    }

    if (self.isImho) {
      result.isClickable = self.vastData['clickthrough'] && self.vastData['clickthrough'].length;
      var clickable = result.isClickable ? 1 : 0;
      var isVpaid = self.vastData.mediaFile[0].apiFramework && self.vastData.mediaFile[0].apiFramework.toUpperCase() === 'VPAID';
      self.vastData['isClickable'] ? self.vastData['isClickable'].push(clickable) : self.vastData['isClickable'] = [ clickable ];

      // MHP-1711: Если это IMHO и это VPAID и у нас нет clickthrough то ставим isClickable = 0 несмотря на то что он присутствует в VAST
      if (!result.isClickable && isVpaid) self.vastData['isClickable'] = [ 0 ];
    }

    return result;
  };

  var _processNode = function (pNode) {

    _parseNode(pNode);
    for (var i = 0; i < pNode.childNodes.length; i++) {
      _processNode(pNode.childNodes[i]);
    }
  };

  var _parseNode = function (pNode) {
    if (!pNode.localName) {
      return;
    }

    var text = pNode.textContent.replace(spaceRegExr, '');
    var name = pNode.localName.toLowerCase();
    if (name == 'ad') {
      var id = pNode.getAttribute('id');
      _processData(name, id);
    } else if (name == 'adtitle') {
      _processData(name, text);
    } else if (name == 'adsystem') {
      _processData(name, text);
    } else if (name == 'vastadtaguri') {
      _processData(name, text);
    } else if (name == 'linear') {
      var skipOffset = pNode.getAttribute('skipoffset');
      if (skipOffset) {
        var node = document.createElement('extension');
        node.setAttribute('type', 'skipTime2');
        node.innerText = skipOffset;
        _processExtensions(node);
      }
    } else if (name == 'tracking' || name == 'clicktracking') {
      var type = pNode.parentNode.parentNode.nodeName;
      type == 'NonLinearAds' ? _processTrackingNonLinear(pNode) : _processTracking(pNode);
    } else if (name == 'duration') {
      _processData(name, _getSeconds(text));
    } else if (name == 'clickthrough') {
      _processData(name, text);
    } else if (name == 'nonlinearclickthrough') {
      _processData(name, text);
    } else if (name == 'extension') {
      _processExtensions(pNode);
    } else if (name == 'impression') {
      if (!self.trackingData['impression']) {
        self.trackingData['impression'] = [];
      }
      if (!self.trackingDataNonLinear['impression']) {
        self.trackingDataNonLinear['impression'] = [];
      }
      self.trackingData['impression'].push(text);
      self.trackingDataNonLinear['impression'].push(text);
    } else if (name == 'mediafile') {
      _processMedia(pNode);
    } else if (name == 'nonlinearads') {
      _processNonLinerMedia(pNode);
    } else if (name == 'error') {
      if (!self.trackingData['error']) {
        self.trackingData['error'] = [];
      }
      if (!self.trackingDataNonLinear['error']) {
        self.trackingDataNonLinear['error'] = [];
      }
      self.trackingData['error'].push(text);
      self.trackingDataNonLinear['error'].push(text);
    } else if (name == 'adparameters') {
      if (text.length > 1) _processData(name, text);
    }
  };

  var _processMedia = function (pMedia) {
    var mediaAttributes = pMedia.attributes;
    var processingObject = {};
    for (var i = 0; i < mediaAttributes.length; i++) {
      processingObject[mediaAttributes[i].localName] = mediaAttributes[i].value;
    }
    processingObject['url'] = pMedia.textContent.replace(spaceRegExr, '');

    if (AdConsts.DEVICE_TYPE !== 'tv') {
      if (AdConsts.PROTOCOL === 'https:') {
        processingObject['url'] = processingObject['url'].replace(/^https?:/, '');
      }
    }

    if (processingObject.type === "application/x-shockwave-flash") return;

    _processData('mediaFile', processingObject);
  };

  var _processNonLinerMedia = function (pNode) {
    var mediaDuration, mediaFile, mediaFileAttributes, mediaFileAttributes2, mediaHeight, mediaScalable, mediaType,
      mediaUrl, mediaWidth;

    mediaFile = pNode.getElementsByTagName('StaticResource')[0];
    if (!mediaFile) {
      return;
    }
    self.isLinear = false;
    mediaUrl = mediaFile.textContent.replace(spaceRegExr, '');

    mediaFileAttributes = mediaFile.attributes;
    var length, i;
    for (i = 0, length = mediaFileAttributes.length; i < length; i++) {
      switch (mediaFileAttributes[i].nodeName) {
        case 'creativeType':
          mediaType = mediaFileAttributes[i].nodeValue;
          break;
      }
    }

    mediaFileAttributes2 = pNode.getElementsByTagName('NonLinear')[0].attributes;
    for (i = 0, length = mediaFileAttributes2.length; i < length; i++) {
      switch (mediaFileAttributes2[i].nodeName) {
        case 'width':
          mediaWidth = mediaFileAttributes2[i].nodeValue;
          break;
        case 'height':
          mediaHeight = mediaFileAttributes2[i].nodeValue;
          break;
        case 'scalable':
          mediaScalable = mediaFileAttributes2[i].nodeValue;
          break;
        case 'minSuggestedDuration':
          var temp = mediaFileAttributes2[i].nodeValue.split(':');
          mediaDuration = (+temp[0]) * 60 * 60 + (+temp[1]) * 60 + (+temp[2]);
          break;
      }
    }

    _processData('mediaFile', {
      url: mediaUrl,
      type: mediaType,
      duration: mediaDuration,
      width: mediaWidth,
      height: mediaHeight,
      scalable: mediaScalable
    });
  };

  var _processData = function (pKey, pData) {
    if (!self.vastData[pKey]) {
      self.vastData[pKey] = [];
    }
    self.vastData[pKey].push(pData);
  };

  var _processTracking = function (pTracking) {
    var eventType, savedData;
    if (pTracking.nodeName == 'ClickTracking') {
      eventType = "clicktracking";
    } else {
      eventType = pTracking.attributes[0].value;
    }

    var text = pTracking.textContent.replace(spaceRegExr, '');
    if (eventType == 'progress' && pTracking.attributes[1] && pTracking.attributes[1].name == 'offset') {
      savedData = { offset: pTracking.attributes[1].value, url: text };
    } else {
      savedData = text;
    }
    if (!self.trackingData[eventType]) {
      self.trackingData[eventType] = [];
    }
    self.trackingData[eventType].push(savedData);
  };

  var _processTrackingNonLinear = function (pTracking) {
    var eventType, savedData;
    if (pTracking.nodeName == 'ClickTracking') {
      eventType = "clicktracking";
    } else {
      eventType = pTracking.attributes[0].value;
    }

    var text = pTracking.textContent.replace(spaceRegExr, '');
    if (eventType == 'progress' && pTracking.attributes[1] && pTracking.attributes[1].name == 'offset') {
      savedData = { offset: pTracking.attributes[1].value, url: text };
    } else {
      savedData = text;
    }
    if (!self.trackingDataNonLinear[eventType]) {
      self.trackingDataNonLinear[eventType] = [];
    }
    self.trackingDataNonLinear[eventType].push(savedData);
  };

  var _processExtensions = function (pExtension) {
    if (pExtension.attributes.length == 0 || !pExtension.attributes[0].value) {
      return;
    }
    var extensionName = pExtension.attributes[0].value;
    var text = pExtension.textContent.replace(spaceRegExr, '');

    if (extensionName == 'skipAd' || extensionName == 'addClick') {
      _processTracking(pExtension);
      return;
    }

    if (!self.vastData[extensionName]) {
      self.vastData[extensionName] = [];
    }
    var value;

    if (extensionName == 'startTime' || extensionName == 'skipTime' || extensionName == 'skipTime2') {
      value = _getSeconds(text);
      if (self.isImho && extensionName == 'skipTime2') {
        var player = Observer.getObserverInstance();
        if (player && player.config && player.config.deviceType === 'tv') {
          !self.vastData['skipTime'] ? self.vastData['skipTime'] = [ value ] : self.vastData['skipTime'].push(value);
        }
      }
    } else if (extensionName == 'isClickable') {
      value = parseInt(text);
    } else if (extensionName == 'controls') {
      value = self.isImho ? _processControlsElements(pExtension) : parseInt(text);
    } else if (extensionName == 'Urlmod') {
      var final = pExtension.attributes.length > 3 && pExtension.attributes[3].name === 'final' ? pExtension.attributes[3].value === "true" : false;
      if (final) {
        self.vastData[AdConsts.ALLOW_BLOCK] ? self.vastData[AdConsts.ALLOW_BLOCK].push(0) : self.vastData[AdConsts.ALLOW_BLOCK] = [ 0 ];
        return;
      }
    } else if (extensionName == 'linkTxt') {
      if (text.indexOf('#') != -1) {
        value = _convertASCIItoString(text);
      } else if (text.indexOf('%') != -1) {
        value = decodeURI(text);
        value = value.charAt(0).toUpperCase() + value.substr(1);
      } else {
        value = text;
      }
    } else {
      value = text;
    }

    self.vastData[extensionName].push(value);
  };

  var _processControlsElements = function(pElement) {
    var result = 0;

    for (var i = 0; i < pElement.childNodes.length; i++) {
      var control = pElement.childNodes[i];
      if (control.localName === 'control') {
        var value = parseInt(control.attributes[1].value);
        var name = control.attributes[0].value;
        self.vastData[name] ? self.vastData[name].push(value) : self.vastData[name] = [ value ];
        if (value === 1) {
          result = 1;
        }
      }
    }

    return result;
  };

  var _convertASCIItoString = function (pASCII) {
    pASCII = pASCII.replace(/&amp;/g, '');
    var spaces = pASCII.split(' ', 10);
    var result = '';

    for (var space = 0; space < spaces.length; space++) {
      var chars = spaces[space].split('#', 100);
      for (var charNumber = 0; charNumber < chars.length; charNumber++) {
        if (chars[charNumber] === '&') {
          continue;
        }
        if (charNumber == 1 && space == 0) {
          result += String.fromCharCode(parseInt(chars[charNumber])).toUpperCase();
        } else {
          result += String.fromCharCode(parseInt(chars[charNumber]));
        }
      }

      if (space < spaces.length - 1) {
        result += ' ';
      }
    }

    return result;
  };

  var _getSeconds = function (pTime) { // convert 01:12:22 or 06:15 to seconds
    var values = pTime.split(':', 3);
    if (values.length == 3) {
      return parseInt(values[0]) * 3600 + parseInt(values[1]) * 60 + parseInt(values[2]);
    } else {
      return parseInt(values[0]) * 60 + parseInt(values[1]);
    }
  };

  var _close = function () {
    //this.currentURL  = null;
    // this.currentType = null;
    self.trackingData = {};
    self.vastData = {};
    self.showed = false;
  };

  var _log = function (message) {
    Logger.log(message);
    if (self.logElement) {
      document.getElementById(self.logElement).style.display = 'block';
      document.getElementById(self.logElement).innerHTML += message + '\r\n';
    }
  };

  var _sendTrackingEvent = function (pType, isManyTimesEvent) {

    if (self.trackingData[pType] || self.trackingDataNonLinear[pType]) {
      Observer.emit(AdConsts.VAST_EVENT, pType);
      var tData = self.isLinear ? self.trackingData : self.trackingDataNonLinear;
      if (!tData[pType]) return;

      for (var i = 0; i < tData[pType].length; i++) {
        _log('adt_' + pType);
        try {
          var url = AdURLModificator.getInstance().replaceEventURL(tData[pType][i].replace(/amp;/g, ''));

          if (url && url.length > 5) {
            var img = document.createElement('img');
            img.src = url;
          }
        } catch (err) {
          // do nothing
        }
      }
    }

    if (!isManyTimesEvent && tData && tData[pType]) {
      tData[pType] = null;
    }
  };

  var _sendClickThroughEvent = function () {
    try {
      if (self.vastData) {
        var i, url, img;
        if (self.isLinear && self.vastData['clickthrough'] && self.vastData['clickthrough'].length > 0) {
          Observer.emit(AdConsts.VAST_EVENT, 'clickthrough');
          for (i = 0; i < self.vastData['clickthrough'].length; ++i) {
            _log('adt_clickthrough');
            url = AdURLModificator.getInstance().replaceEventURL(self.vastData['clickthrough'][i].replace(/amp;/g, ''));

            img = document.createElement('img');
            img.src = url;
          }
        } else if (!self.isLinear && self.vastData['nonlinearclickthrough'] && self.vastData['nonlinearclickthrough'].length > 0) {
          //yes, we combine these clicks in one clickthrough VAST_EVENT event
          Observer.emit(AdConsts.VAST_EVENT, 'clickthrough');
          for (i = 0; i < self.vastData['nonlinearclickthrough'].length; ++i) {
            _log('adt_nonlinearclickthrough');
            url = AdURLModificator.getInstance().replaceEventURL(self.vastData['nonlinearclickthrough'][i].replace(/amp;/g, ''));

            img = document.createElement('img');
            img.src = url;
          }
        }
      }
    } catch (error) {
    }
  };

  this.sendReadyEvents = function () {
    _sendTrackingEvent('impression');
    setTimeout(function () {
      _sendTrackingEvent('creativeView');
    }, 20);
  };

  this.sendStartEvent = function () {
    if (!self.trackStarted) {
      setTimeout(function () {
        _sendTrackingEvent('start');
      }, 50);
      self.trackStarted = true;
    }

    var player = Observer.getObserverInstance();
    if (player && player.config && 'adSpeed' in player.config) {
      adSpeed = player.config.adSpeed / 100;
      if (adSpeed < 1) {
        adSpeed = 1;
      } else if (adSpeed > 2) {
        adSpeed = 2;
      }
    }
  };

  this.onTime = function (position, duration) {

    //Иногда некоторые телеки (тайзен) на первых секундах не знают про duration.
    // чтобы не трекаличь все события добавлена эта проверка
    if (!self.showed || duration <= 0 || isNaN(duration)) {
      return;
    }

    position *= adSpeed;

    if (!self.trackFirstQuartile && position >= Math.floor(duration * 25 / 100)) {
      _sendTrackingEvent('firstQuartile');
      self.trackFirstQuartile = true;
    }

    if (!self.trackMidpoint && position >= Math.floor(duration * 50 / 100)) {
      _sendTrackingEvent('midpoint');
      self.trackMidpoint = true;
    }

    if (!self.trackThirdQuertile && position >= Math.floor(duration * 75 / 100)) {
      _sendTrackingEvent('thirdQuartile');
      self.trackThirdQuertile = true;
    }

    if (!self.trackEnd && position >= Math.floor(duration * 99 / 100)) {
      _sendTrackingEvent('complete');
      self.trackEnd = true;
    }

    var progressObj = self.isLinear ? self.trackingData['progress'] : self.trackingDataNonLinear['progress'];
    if (progressObj && progressObj.length > 0) {
      var time;
      for (var i = 0, l = progressObj.length; i < l; ++i) {
        time = _getSeconds(progressObj[i].offset);
        if (time == position && progressObj[i].url) {
          progressObj[i].url = AdURLModificator.getInstance().replaceEventURL(progressObj[i].url);

          var img = document.createElement('img');
          img.src = progressObj[i].url;
        }
      }
    }

  };

  function onImgEvent(event) {
    event.currentTarget.removeEventListener('load', onImgEvent);
    event.currentTarget.removeEventListener('error', onImgEvent);
    if (event.currentTarget.parentNode) {
      event.currentTarget.parentNode.removeChild(event.currentTarget);
    }
  }

  this.click = function () {
    _sendTrackingEvent('clicktracking', true);
    _sendClickThroughEvent();
  };

  this.click2 = function () {
    _sendTrackingEvent('addClick', true);
    _sendTrackingEvent('clicktracking', true);
    _sendClickThroughEvent();
  };

  this.mute = function () {
    _sendTrackingEvent('mute', true);
  };

  this.unmute = function () {
    _sendTrackingEvent('unmute', true);
  };

  this.pause = function () {
    _sendTrackingEvent('pause', true);
  };

  this.resume = function () {
    _sendTrackingEvent('resume', true);
  };

  this.skip = function () {
    _sendTrackingEvent('skipAd');
    _sendTrackingEvent('skip');
    _sendTrackingEvent('closeLinear');
  };

  this.skip2 = function () {
    _sendTrackingEvent('close');
    _sendTrackingEvent('closeLinear');
  };

  this.error = function () {
    _sendTrackingEvent('error');
  };

  //vpaid events
  this.close = function () {
    self.skip2();
  };

  this.collapse = function () {
    _sendTrackingEvent('collapse', true);
  };

  this.creativeView = function () {
    _sendTrackingEvent('creativeView');
  };

  this.fullscreen = function () {
    _sendTrackingEvent('fullscreen', true);
  };

  this.expand = function () {
    _sendTrackingEvent('expand', true);
  };

  this.impression = function () {
    _sendTrackingEvent('impression');
  };

  this.start = function () {
    _sendTrackingEvent('start');
  };

  this.stop = function () {
    _sendTrackingEvent('stop');
  };

  this.acceptInvitation = function () {
    _sendTrackingEvent('acceptInvitation', true);
  };

  this.firstQuartile = function () {
    _sendTrackingEvent('firstQuartile');
  };

  this.midpoint = function () {
    _sendTrackingEvent('midpoint');
  };

  this.thirdQuartile = function () {
    _sendTrackingEvent('thirdQuartile');
  };

  this.complete = function () {
    _sendTrackingEvent('complete');
  };
}

VastDocument.prototype.constructor = VastDocument;
